export * from './compare.js';
export * from './labs.js';
export * from './local-storage.js';
export * from './modals.js';
export * from './mosaics.js';
export * from './orders.js';
export * from './preferences.js';
export * from './processes.js';
export * from './tour.js';
export * from './sort.js';

export const ITEM_COUNT_LIMIT = 100;
export const DEFAULT_ZOOM = 2;
export const DRAG_TYPE = 'Text';
export const MAX_FULL_ACCESS_ZOOM = 15; // highest resolution basemap tiles available
export const MAX_SKYSAT_LIMITED_ACCESS_ZOOM = 13; // SkySat tiles outside constraint geometry stop here
export const MAX_ZOOM = 20; // map stops here
export const MAX_FOLDERS_ZOOM = 22; // map stops here for folders
export const MAX_LIMITED_ACCESS_ZOOM = 10; // SS tiles outside constraint geometry stop here

/** Downsampling Limits */
export const DOWNSAMPLE_ZOOM = 11;
export const DOWNSAMPLE_THRESHOLD = 0.25;

export const MAX_TILESET_ITEMS = 30;
export const MAX_VISIBLE_RESULTS = 10;

export const MAX_GEOMETRY_AREA = 50000; // Maximum area in square km

export const UI_MODES = {
  BROWSE: 'browse',
  COMPARE: 'compare',
  SNAPSHOT: 'snapshot',
};

export const FOLDER_GROUPS = {
  MY_FOLDERS: 'My Folders',
  DEMO_FOLDER: 'Demo Data',
};

export const trackingName = 'Explorer interaction';

export const SERIES_DELIM = '.';

export const DEFAULT_PROCESS = 'rgb';

export const GEO_PROJECTION = 'EPSG:4326';
export const WEB_PROJECTION = 'EPSG:3857';

export const PROJECTION_LABELS = {
  3857: 'Web Mercator (EPSG: 3857)',
  4326: 'World Geodetic System (EPSG: 4326)',
};

export const DEFAULT_OVERLAYS = {
  labels: true,
  user: false,
  stiles: true,
};

export const TILE_MODE = {
  FOLDERS: 'mode-folders',
  RESULTS: 'mode-results',
  BASEMAPS: 'mode-basemaps',
};

export const ENHANCEMENT_MODE = {
  OFF: 'off',
  AUTO: 'auto',
  SNOW: 'snow',
  DESERT: 'desert',
  MANUAL: 'manual',
};

export const DRAWERS = {
  SEARCH: 'search-drawer',
  ORDERS: 'orders-drawer',
  SETTINGS: 'settings-drawer',
  COLORENHANCE: 'colorenhance-drawer',
  PROCESS: 'process-drawer',
  SAVED_SEARCHES: 'saved-searches-drawer',
  FOLDERS: 'folders-drawer',
  BASEMAPS: 'basemaps-drawer',
};

export const DEFAULT_CURVES = {
  256: [
    [0, 0],
    [0.33, 0.33],
    [0.66, 0.66],
    [1.0, 1.0],
  ],
  10000: [
    [0.00941650390625, 0.065],
    [0.07441650390625, 0.685],
    [0.16941650390625, 0.875],
    [0.37441650390625, 0.995],
  ],
  65536: [
    [0.00941650390625, 0.065],
    [0.07441650390625, 0.685],
    [0.16941650390625, 0.875],
    [0.37441650390625, 0.995],
  ],
};

export const CONTACT_SALES_URL =
  'https://learn.planet.com/contact-us-explorer.html';

/**
 * SUBSCRIPTIONS
 */

// Trials
export const EVALUATION_PROGRAM_ID = 29;

export const TRIAL_PLAN_ID = 662; //Global AOI Trial
export const UPGRADEABLE_IDS = [76, 164];
// 76 = OpenCA
// 164 = Open Cailfornia - No Delay
export const FREEMIUM_PLAN_IDS = UPGRADEABLE_IDS.concat([TRIAL_PLAN_ID]);

export const QUOTA_TYPES = {
  SCENE: 'scene',
  BASEMAP: 'basemap',
};

export const TILE_MODE_QUOTA = {
  [TILE_MODE.BASEMAPS]: QUOTA_TYPES.BASEMAP,
  [TILE_MODE.RESULTS]: QUOTA_TYPES.SCENE,
};

export const QUOTA_TYPE_KEYS = {
  [QUOTA_TYPES.SCENE]: 'scene_tile_quota',
  [QUOTA_TYPES.BASEMAP]: 'basemap_tile_quota',
};

export const TILE_QUOTA_LABELS = {
  [QUOTA_TYPES.SCENE]: 'Scene Tiles',
  [QUOTA_TYPES.BASEMAP]: 'Basemap Tiles',
};

export const INFINITE_QUOTA_CAP = Math.pow(2, 31) - 1;

export const MAP_TOOLS = {
  DRAW_LOCKED_CIRCLE: 'draw-locked-circle',
  DRAW_LOCKED_RECT: 'draw-locked-rect',

  DRAW_POLYGON: 'draw-polygon',
  DRAW_CIRCLE: 'draw-circle',
  DRAW_RECT: 'draw-rect',
  DRAW_LINE: 'draw-line',

  EDIT: 'draw-edit',

  BOX_ZOOM: 'box-zoom',

  NONE: '',
};

export const MAP_DRAW_LAYERS = {
  GEOMETRY: 'geometry',
  MEASURE: 'measure',
  NONE: 'none',
};
